import { useState, useEffect } from 'react';
import OkrService from '../services/okrs';

export const useFetchOneOnOneObjectives = ({ 
  loadingDirectReportee, 
  directReporteeId,
  managerId,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [response, setResponse] = useState({
    manager: {
      error: null, data: null
    }, 
    directReportee: {
      error: null, data: null
    }});

  const handleFetchData = async () => {
    let errManager, dataManager, errReportee, dataReportee;
    if (directReporteeId) {
      [errReportee, dataReportee] = await OkrService.getObjectivesByUserId({ userId: directReporteeId });
    }
    if (managerId) {
      [errManager, dataManager] = await OkrService.getObjectivesByUserId({ userId: managerId });
    }
    setResponse({
      manager: { error: errManager, data: dataManager },
      directReportee: { error: errReportee, data: dataReportee }
    });
    setIsLoading(false);
  };
    
  useEffect(() => {
    if(!loadingDirectReportee) handleFetchData();
  },[loadingDirectReportee, directReporteeId, managerId]);

  return { loadingDirectReporteeObjectives: isLoading , response };
};
